// ------------------------------------------------------------------------------
//      Require all SVG icons (this is for webpack only)
// ------------------------------------------------------------------------------

const svgIcons = require.context('../../svg', true, /\.svg$/);
svgIcons.keys().forEach(svgIcons);
